import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setInfoModalOpen, setInfoModalProps } from '../redux/ducks/UIDucks';
import type {
  InfoModalActionType,
  InfoModalPropsType,
} from '../redux/ducks/UIDucks.types';
import type { RootReducerType } from '../redux/reducers/RootReducer.types';

interface InfoModalStore {
  isOpen: boolean;
  currentAction: InfoModalActionType | undefined;
  onOpen: (props: InfoModalPropsType) => void;
  onClose: () => void;
}

const useInfoModal = (): InfoModalStore => {
  const dispatch = useDispatch();

  const { isInfoModalOpen: modalIsOpen, infoModalProps: currentModalProps } =
    useSelector((state: RootReducerType) => state.ui);

  const { onInfoModalClose } = useSelector(
    (state: RootReducerType) => state.ui,
  );

  const currentModalAction = useMemo<InfoModalActionType | undefined>(() => {
    if (currentModalProps) {
      return currentModalProps.action;
    }

    return undefined;
  }, [currentModalProps]);

  useEffect(() => {
    if (onInfoModalClose) {
      dispatch(setInfoModalOpen(false));
    }
  }, [onInfoModalClose, dispatch]);

  const onOpen = (props: InfoModalPropsType) => {
    dispatch(setInfoModalProps(props));
    dispatch(setInfoModalOpen(true));
  };

  const onClose = () => {
    dispatch(setInfoModalOpen(false));
  };

  return {
    isOpen: modalIsOpen,
    currentAction: currentModalAction,
    onOpen,
    onClose,
  };
};

export default useInfoModal;
